import { render, staticRenderFns } from "./auditCombination.vue?vue&type=template&id=4fcbafb6&scoped=true&"
import script from "./auditCombination.vue?vue&type=script&lang=js&"
export * from "./auditCombination.vue?vue&type=script&lang=js&"
import style0 from "./auditCombination.vue?vue&type=style&index=0&id=4fcbafb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcbafb6",
  null
  
)

export default component.exports